module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_CrystalPalace.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_CrystalPalace.png
// module id = 2185
// module chunks = 4